module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-2 col-md-8",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('cart-widget')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section is-dark is-header md-margin-top-24"
  }, [_c('div', {
    staticClass: "container margin-top"
  }, [_c('div', {
    staticClass: "col block-centered text-align-center lg-7 md-12"
  }, [_c('div', {
    staticClass: "padding-left padding-right margin-bottom low-text-contrast on-dark"
  }, [_vm._v("Process order "), _c('a', {
    staticClass: "on-dark",
    attrs: {
      "href": "/shops"
    }
  }, [_vm._v("or Continue shopping")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b5389d0"}!./src/pages/Orderpoint/Order/template.html
// module id = 274
// module chunks = 0